import { render, staticRenderFns } from "./DivideGroupsDialog.vue?vue&type=template&id=4f290f04&scoped=true&"
import script from "./DivideGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./DivideGroupsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DivideGroupsDialog.vue?vue&type=style&index=0&id=4f290f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f290f04",
  null
  
)

export default component.exports